function copyToClipboard(value) {
	if (navigator?.clipboard) {
		navigator.clipboard.writeText(value).catch((err) => {
			console.error('Failed to copy text: ', err);
		});
	}
}

export { copyToClipboard };
